import { createStore } from "vuex";
import { createIdle, idleVue } from "@/store/idle.js";
import createApiStore from "@/store/api/index.js";
import state from "@/store/state.js";
import mutations from "@/store/mutations.js";
import actions from "@/store/actions.js";
import getters from "@/store/getters.js";
import createFilterBarStore from "@/store/filterBar/index.js";

export default () => {
  const store = createStore({
    state,
    mutations,
    actions,
    getters,
    modules: {
      idleVue,
      api: createApiStore(),
      filterBar: createFilterBarStore(),
    },
  });
  createIdle(store);
  return store;
};
